import Swal from "sweetalert2";

import api from "./api";
import { InstrucaoBancariaDto } from "../shared/dtos/InstrucaoBancaria.dto";

class InstrucaoBancariaService {
  async getAllInstrucaoBancaria(): Promise<InstrucaoBancariaDto[]> {
    return api
      .get("/instrucao-bancaria/find-all")
      .then((response) => {
        return Promise.resolve(response.data as InstrucaoBancariaDto[]);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar instruções bancárias`);
        return Promise.reject(error);
      });
  }

  async getInstrucaoBancariaById(id: number): Promise<InstrucaoBancariaDto> {
    return api
      .get(`/instrucao-bancaria/get-by-id/${id}`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar instrução bancária com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async createInstrucaoBancaria(instrucaoBancariaData: InstrucaoBancariaDto): Promise<InstrucaoBancariaDto> {
    return api
      .post("/instrucao-bancaria/create", instrucaoBancariaData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, "Erro ao criar instrução bancária");
        return Promise.reject(error);
      });
  }

  async updateInstrucaoBancaria(id: number, instrucaoBancariaData: InstrucaoBancariaDto): Promise<InstrucaoBancariaDto> {
    return api
      .patch(`/instrucao-bancaria/update/${id}`, instrucaoBancariaData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao atualizar instrução bancária com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async deleteInstrucaoBancaria(id: number): Promise<void> {
    return api
      .delete(`/instrucao-bancaria/delete/${id}`)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        this.handleError(error, `Erro ao deletar instrução bancária com ID ${id}`);
        return Promise.reject(error);
      });
  }

  private handleError(error: any, message: string): void {
    if (error.response) {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.response.data}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.message || "Erro desconhecido"}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  }
}

const instrucaoBancariaService = new InstrucaoBancariaService();
export default instrucaoBancariaService;
